<h2 mat-dialog-title
  >Remove Lineup {{ game?.homeTeam }} - {{ game?.awayTeam }}</h2
>
<mat-dialog-content>
  <b>Removing players without any events will clear their lineup fields.</b>
  <div class="row" style="margin-top: 24px">
    <div class="col-4">Apply To</div>
    <div class="col-8">
      <div style="margin-bottom: 8px">
        <mat-checkbox [(ngModel)]="teams.home"
          >Home: {{ game?.homeTeam }}</mat-checkbox
        >
      </div>
      <div>
        <mat-checkbox [(ngModel)]="teams.away"
          >Away: {{ game?.awayTeam }}</mat-checkbox
        >
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" (click)="close(false)"
    >Cancel</button
  >
  <button mat-raised-button color="warn" (click)="close(true)">Remove</button>
</mat-dialog-actions>
